module.exports = __webpack_public_path__ + "img/header-parallax-4.10f94834.jpg";